import {
	FormControl,
	FormControlLabel,
	FormLabel,
	RadioGroup,
	TextField,
	Radio,
	Stack,
	Typography,
} from '@mui/material';
import React, { ChangeEvent, FC, useCallback, useEffect, useState } from 'react';
import { useTranslation } from '../../services';

interface SearchInterface {
	fields: string[];
	onSearch: (search: { searchBy: string; value: string }) => void;
}

const Search: FC<SearchInterface> = ({ fields, onSearch }) => {
	const { t } = useTranslation();
	const [timer, setTimer] = useState<NodeJS.Timeout>();
	const [search, setSearch] = useState<string>('');
	const [searchBy, setSearchBy] = useState<(typeof fields)[number]>(fields[0]);

	const handleSearchBy = useCallback(
		(e: ChangeEvent<HTMLInputElement>) => {
			setSearchBy(e.target.value);
		},
		[setSearchBy]
	);

	const handleSearch = useCallback(
		(e: ChangeEvent<HTMLInputElement>) => {
			timer && clearTimeout(timer);
			setSearch(e.target.value);
		},
		[timer, setSearch]
	);

	useEffect(() => {
		setTimer(
			setTimeout(() => {
				onSearch({ searchBy, value: search });
			}, 1600)
		);
	}, [search, searchBy]);

	return (
		<Stack direction="column" spacing={2}>
			<TextField
				label={t('Search')}
				variant="outlined"
				value={search}
				onChange={handleSearch}
			/>
			{searchBy === 'search' && (
				<Typography variant="body2">
					{t('Can be')}: &nbsp;
					{fields.filter((f) => f !== 'search').map((field) => (
						`${t(field.replace(/^./, (val) => val.toUpperCase()))}`
					)).join(',  ')}
				</Typography>
			)}
			<FormControl>
				<FormLabel>{t('Search by')}:</FormLabel>
				<RadioGroup
					row
					name="searchBy"
					value={searchBy}
					onChange={handleSearchBy}
				>
					{fields.map((field) => (
						<FormControlLabel
							key={field}
							value={field}
							control={<Radio />}
							label={t(
								field === 'search'
									? 'All'
									: field.replace(/^./, (val) => val.toUpperCase())
							)}
						/>
					))}
				</RadioGroup>
			</FormControl>
		</Stack>
	);
};

export default Search;
